<template>
  <property-report-card
    title="5-Year Occupancy Forecast"
    description="Projected occupancy rates for this property are based on HelloData's dynamic forecasting model."
    :loading="isLoading"
    :printing-mode="printingMode"
  >
    <template #actions>
      <q-select
        v-model="frequency"
        :disable="isLoading"
        :options="frequencyOptions"
        dense
        emit-value
        label="Frequency"
        map-options
        outlined
        style="width: 150px"
        transition-duration="100"
        @update:model-value="
          (val) => $tracker.changedFilter('frequency', 'occupancy_projections', val)
        "
      />
    </template>
    <q-separator />
    <occupancy-projections-chart
      :is-single-property="true"
      :frequency="frequency"
      :single-property="singleProperty"
    >
      <template v-if="!singleProperty" #empty-state>
        <div
          class="full-width full-height flex flex-center text-center text-primary"
          style="font-size: 12px"
        >
          Subject Property Required
        </div>
      </template>
    </occupancy-projections-chart>
    <q-card-section class="q-gutter-y-sm">
      <div class="text-weight-bold">How Our Forecasts Work</div>
      <div style="font-size: 12px">
        HelloData's occupancy projections are generated using a deep-learning model designed
        specifically for multifamily markets.
      </div>
    </q-card-section>
  </property-report-card>
</template>

<script lang="ts">
import { type PropType, computed } from 'vue'
import type { PropertyDetailsResponse } from 'common'
import { useSinglePropertyRentProjection } from '@/queries/rentProjections.ts'
import PropertyReportCard from '@/components/PropertyReportCard.vue'
import OccupancyProjectionsChart from '@/components/Charts/OccupancyProjectionsChart.vue'

export default {
  name: 'PropertyCompareOccupancyProjections',
  props: {
    singleProperty: {
      type: Object as PropType<PropertyDetailsResponse | null>,
      default: null
    },
    printingMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PropertyReportCard,
    OccupancyProjectionsChart
  },
  data() {
    return {
      frequency: 'yearly' as 'yearly' | 'monthly',
      frequencyOptions: [
        { label: 'Yearly', value: 'yearly' },
        { label: 'Monthly', value: 'monthly' }
      ]
    }
  },
  setup(props) {
    const lat = computed(() => props.singleProperty?.lat ?? null)
    const lng = computed(() => props.singleProperty?.lon ?? null)
    const { isLoading } = useSinglePropertyRentProjection(lat, lng)
    return { isLoading }
  }
}
</script>
